import React, { useContext } from 'react';
import { RicosContext } from 'ricos-context';
import { s as styles, D as DividerLine } from './divider-line.js';
import classNames from 'classnames';
import { mergeStyles } from 'wix-rich-content-common';
import 'prop-types';
import './viewer-loadable2.js';
import '@loadable/component';
import 'ricos-types';

var DividerViewer = function DividerViewer(_ref) {
  var componentData = _ref.componentData;
  var _a, _b, _c;
  var _useContext = useContext(RicosContext),
    theme = _useContext.theme,
    isMobile = _useContext.isMobile;
  var dividerStyles = mergeStyles({
    styles: styles,
    theme: theme
  });
  var lineStyle = (_a = componentData.lineStyle) == null ? void 0 : _a.toLowerCase();
  var className = classNames(dividerStyles["divider-container"], dividerStyles["divider-container--" + lineStyle], isMobile && dividerStyles["divider-container--mobile"]);
  return /* @__PURE__ */React.createElement("div", {
    className: className,
    "data-hook": "divider-" + lineStyle
  }, /* @__PURE__ */React.createElement(DividerLine, {
    type: lineStyle,
    width: "100%",
    size: (_b = componentData.width) == null ? void 0 : _b.toLowerCase(),
    alignment: (_c = componentData.alignment) == null ? void 0 : _c.toLowerCase(),
    styles: dividerStyles,
    isMobile: isMobile
  }));
};

var Divider = function Divider(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    key: node.id,
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(DividerViewer, {
    componentData: node.dividerData
  }));
};

export { Divider as default };

import 'wix-rich-content-plugin-divider/dist/loadable/viewer/es/styles.viewer.min.global.css'